function IconListNumbers({
  color = 'currentColor',
  size = 28,
}: {
  color?: string;
  size?: number;
}) {
  return (
    <svg width={size} height={size} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.6667 6H20.6667M11.6667 12H20.6667M12.6667 18H20.6667M4.66675 16C4.66675 15.4696 4.87746 14.9609 5.25253 14.5858C5.62761 14.2107 6.13632 14 6.66675 14C7.19718 14 7.70589 14.2107 8.08096 14.5858C8.45603 14.9609 8.66675 15.4696 8.66675 16C8.66675 16.591 8.16675 17 7.66675 17.5L4.66675 20H8.66675M6.66675 10V4L4.66675 6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

IconListNumbers.displayName = 'IconListNumbers';

export default IconListNumbers;
